export default {"src":"/_next/static/media/world-icon.4f255ca9.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};